import { StatementCertData, IStatementCertData } from './types';

enum Action {
  GET_SERT = 'toggleStatement',
  ACTION_TEXT = 'Подать заявление на активацию сертификата',
}

const statementCertData = (data: IStatementCertData): StatementCertData => ({
  id: data!.id || '',
  childName:
    data!.last_name && data!.first_name
      ? `${data.last_name} ${data.first_name}`
      : 'Без имени',
  fio: data!.fio || '',
  birthday: data.birthday.length
    ? data.birthday.split('-').reverse().join('.')
    : '',
  isUndefinedType: true,
  isApproved: data!.is_approved,
  certificateId: data!.certificate_id,
  certificateType: data!.certificate_type,
  certificateNumber: data!.certificate_number,
  toIssue: data!.certificate_request ? null : data!.toIssue,
  action: Action.GET_SERT,
  actionText: Action.ACTION_TEXT,
});

export default statementCertData;



// WEBPACK FOOTER //
// ./src/services/pfdod/utils/statementCertData.ts